define('views/modules/template/edit/calendar/calendar-component/template-item-duplicate-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    'services/i18n',
    'services/api',
    // events
    'services/events/calendar-events',
    // models
    'models/template/calendar/template-session',
    'models/template/template',
    // views
    'views/parts/modal/modal',
    'views/parts/form/textbox',
    'views/parts/form/select',
    'views/parts/form/choices',
    // templates
    'text!templates/modules/template/edit/calendar/calendar-component/template-item-duplicate-modal.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // src
    i18n, API,
    // events
    CalendarEvents,
    // models
    MTemplateSession,
    MTemplate,
    // views
    VModal,
    VTextbox,
    VSelect,
    VChoices,
    // templates
    TTemplateItemDuplicateModal
) {

    var VTemplateItemDuplicateModal = VModal.extend({
        template: TTemplateItemDuplicateModal,

        regions: {
            week: ".week-input",
            daysOfWeek: ".days-of-week-input",
            duplicateAllItems: '.duplicate-all-items-checkbox'
        },

        modal: function() {
            return {
                title: i18n.t("calendar:Duplicate activity to"),
                size: "small",
                className: "template-item-duplicate-modal",
            };
        },

        initialize: function(options) {
            this.options = options || {}; // additional options passed to the constructor.
            this.duplicateModel = new Backbone.Model({ duplicateAll: false });

            var CNumberOfWeeks = new Backbone.Collection([
                { label: '1', value: "1" },
                { label: '2', value: "2" },
                { label: '3', value: "3" },
                { label: '4', value: "4" },
                { label: '5', value: "5" },
                { label: '6', value: "6" },
            ]);

            var CDaysOfWeek = new Backbone.Collection([{
                    label: i18n.t("Monday"),
                    value: "0"
                },
                {
                    label: i18n.t("Tuesday"),
                    value: "1"
                },
                {
                    label: i18n.t("Wednesday"),
                    value: "2"
                },
                {
                    label: i18n.t("Thursday"),
                    value: "3"
                },
                {
                    label: i18n.t("Friday"),
                    value: "4"
                },
                {
                    label: i18n.t("Saturday"),
                    value: "5"
                },
                {
                    label: i18n.t("Sunday"),
                    value: "6"
                },
              ]);
            this.view = {
                week: new VSelect({
                    option: { label: 'label', value: 'value', skipTranslation: true },
                    collection: CNumberOfWeeks,
                    context: this,
                    attribute: "numberOfWeeks",
                    model: this.model
                }),
                days: new VSelect({
                    option: { label: 'label', value: 'value', skipTranslation: true },
                    collection: CDaysOfWeek,
                    context: this,
                    attribute: "dayId",
                    model: this.model
                }),
                duplicateAllItems: new VChoices({
                    label: 'calendar:Duplicate all items of the animated session',
                    model: this.duplicateModel,
                    attribute: 'duplicateAll'
                })
            };

            //List of animated Sessions to duplicate
            this.sessionItemsToDuplicate = this.options.sessionItemsToDuplicate;
        },

        isAnimatedSession: function() {
            return this.model.getType() === "animated";
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(
                  _.extend(this.model, { NotAnAnimatedSession: !this.isAnimatedSession()
                                      })
                                    )));

            this.generateZones();

            this.assign(this.view.week, this.zone.$week)
                .assign(this.view.days, this.zone.$daysOfWeek)
                .assign(this.view.duplicateAllItems, this.zone.$duplicateAllItems)
                .renderModal();

            this.view.week.setValue(1);
            this.view.days.setValue(0);

            return this;
        },

        setTemplateId: function(templateSessionInfo) {
            this.options.templateSessionsInfo = templateSessionInfo;
        },

        setModel: function(model) {
            if (!model) return;
            this.model = model;

            return this;
        },

        duplicateSession: function(model) {
          if (this.isAnimatedSession()) {
              this.templateSession = new MTemplateSession();

              var session = this.options.templateSessionsInfo.findWhere({ _id: this.model.get('session') });
              this.templateSession.copyValues(session);

              if (this.duplicateModel.get('duplicateAll') === false) {
                var week = this.model.get('week');
                this.templateSession.set({ num_weeks: 1 });
                this.templateSession.get('exercises').forEach(function(ex) {
                  ex.weeks = [ex.weeks[week]];
                }, this);
              }

              CalendarEvents.sessionUpdate(this.templateSession, null, true);
            }

            this.duplicateItem();
        },

        duplicateItem: function() {

            if (this.view.week.getValue() < 0 || this.view.week.getValue() > 6)
                return;

            var duplicates = [],
                offSet = this.view.days.getValue() - this.model.get('dayId') % 7;

            if (offSet === 0) offSet = 7;

            if (this.isAnimatedSession()) {
                if (this.duplicateModel.get('duplicateAll')) {
                    for (var i = 0; i < this.sessionItemsToDuplicate.length; i++) {
                        duplicates.push(this.model.duplicate({
                            dayId: this.sessionItemsToDuplicate[i].get('dayId') + offSet,
                            session: this.templateSession.id,
                            week: this.sessionItemsToDuplicate[i].get('week')
                        }));
                    }
                } else {
                    duplicates.push(this.model.duplicate({
                        dayId: this.model.get('dayId') + offSet,
                        session: this.templateSession.id,
                        week: 0
                    }));
                }
              }
              else {
                var week = this.view.week.getValue();
                for (var j = 0; j < week; j++) {
                    var dupModel = this.model.duplicate({
                        dayId: this.model.get('dayId') + offSet + j * 7
                      });
                    duplicates.push(dupModel);
                }
              }

            CalendarEvents.itemUpdate(duplicates);
        },

        ////////////
        // events //
        ////////////
        onConfirm: function(confirmed) {
            if (!confirmed) return;

            this.duplicateSession();
        }

    });

    return VTemplateItemDuplicateModal;
});

